import { $, $$ } from 'utils/dom';
import EventList from 'modules/event-list';
import Filter from 'modules/Filter/filter';

const $$eventLists = $$('.event-list');
if ($$eventLists.length !== 0) {
  $$eventLists.forEach(eventList => {
    new EventList(eventList).init();
    if ($('.event-list__load-more', eventList)) {
      new Filter({
        container: eventList,
        items: $$('.event-list-item', eventList),
        hiddenClass: 'event-list-item--hidden',
        activeClass: 'event-list-item--active',
        loadMoreNode: $('.event-list__load-more', eventList), // optional: only if you have a load-more button
        defaultItemsToShow: 2, // optional: only active if you are using load-more button
        amountOfItemsToShow: 2, // optional: only active if you are using load-more button
      }).init();
    }
  });
}
